module.exports = __webpack_public_path__ + "img/right-wing.784641ee.png";